export const GET_HARDWARE_PRODUCTS = 'GET_HARDWARE_PRODUCTS';
export const UPDATE_HARDWARE_PRODUCTS = 'UPDATE_HARDWARE_PRODUCTS';
export const GET_HARDWARE_BASE_PRODUCTS = 'GET_HARDWARE_BASE_PRODUCTS';
export const UPDATE_HARDWARE_BASE_PRODUCTS = 'UPDATE_HARDWARE_BASE_PRODUCTS';
export const SET_HARDWARE_LOADING = 'SET_HARDWARE_LOADING';

export const SHOW_CREATE_HARDWARE_MODAL = 'SHOW_CREATE_HARDWARE_MODAL';
export const SHOW_EDIT_HARDWARE_MODAL = 'SHOW_EDIT_HARDWARE_MODAL';
export const SET_HARDWARE_EDITOR_LOADING = 'SET_HARDWARE_EDITOR_LOADING';
export const SET_HARDWARE_EDITOR_ERROR = 'SET_HARDWARE_EDITOR_ERROR';
export const SAVE_HARDWARE_PRODUCT = 'SAVE_HARDWARE_PRODUCT';

export const SHOW_DELETE_HARDWARE_CONFIRMATION =
  'SHOW_DELETE_HARDWARE_CONFIRMATION';
export const SET_HARDWARE_DELETE_LOADING = 'SET_HARDWARE_DELETE_LOADING';
export const DELETE_HARDWARE_PRODUCT = 'DELETE_HARDWARE_PRODUCT';

export const HARDWARE_CATALOGUE_DO_SHOW_LOG = 'HARDWARE_CATALOGUE_DO_SHOW_LOG';
export const HARDWARE_CATALOGUE_LOG_SET_SHOWN =
  'HARDWARE_CATALOGUE_LOG_SET_SHOWN';
export const HARDWARE_CATALOGUE_LOG_CHANGE_PAGE =
  'HARDWARE_CATALOGUE_LOG_CHANGE_PAGE';
export const HARDWARE_CATALOGUE_LOG_SET_DATA =
  'HARDWARE_CATALOGUE_LOG_SET_DATA';
export const HARDWARE_CATALOGUE_LOG_SET_IS_LOADING =
  'HARDWARE_CATALOGUE_LOG_SET_IS_LOADING';
export const HARDWARE_CATALOGUE_LOG_SET_ERRORS =
  'HARDWARE_CATALOGUE_LOG_SET_ERRORS';
